import styled, { css } from 'styled-components';

import { base, colors, screens } from '../../../styles';

import '../../../styles/slick/slick.css';

import '../../../styles/slick/slick-theme.css';

export const Item = styled.div`
  margin-right: 32px;
  font-size: ${base * 2.5}px;
  outline: none;
  ${props => props.active && css`
    color: ${colors.primary};
  `}
`;

export const Heading = styled.h3`
  text-align: center;
  margin: auto;
  cursor: pointer;

  @media (max-width: ${screens.screen_xs_max}) {
    font-size: 18px;
  }

`;
